import FormGroupItem from './form_group_item';

export const create = (formGroupProps) => {
	const formGroupClass = getModelClass();
	return new formGroupClass(formGroupProps);
};

export const getModelClass = () => {
	return FormGroupItem;
};

export default {
	create,
	getModelClass,
};
